import axios from 'axios/index'

import config from '../../config'
import action, { actionFailed } from '../../util/action'
import createAsyncConst from '../../util/createAsyncConst'

export const FETCH_VISIT_CHECKLIST_QUESTIONS = createAsyncConst(
  'FETCH_VISIT_CHECKLIST_QUESTIONS'
)
export const STORE_VISIT_CHECKLIST_QUESTION = createAsyncConst(
  'STORE_VISIT_CHECKLIST_QUESTION'
)
export const UPDATE_VISIT_CHECKLIST_QUESTION = createAsyncConst(
  'UPDATE_VISIT_CHECKLIST_QUESTION'
)
export const REORDER_VISIT_CHECKLIST_QUESTIONS = createAsyncConst(
  'REORDER_VISIT_CHECKLIST_QUESTIONS'
)
export const DELETE_VISIT_CHECKLIST_QUESTION = createAsyncConst(
  'DELETE_VISIT_CHECKLIST_QUESTION'
)

export function fetchVisitChecklistQuestions(filters) {
  return dispatch => {
    dispatch(action(FETCH_VISIT_CHECKLIST_QUESTIONS.ACTION))
    return axios
      .get(`${config.API_URL}/visit-checklist-question`, { params: filters })
      .then(resp => {
        dispatch(action(FETCH_VISIT_CHECKLIST_QUESTIONS.SUCCESS, resp.data))
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_VISIT_CHECKLIST_QUESTIONS, e)))
  }
}

export function storeVisitChecklistQuestion(values) {
  return dispatch => {
    dispatch(action(STORE_VISIT_CHECKLIST_QUESTION.ACTION))
    return axios
      .post(`${config.API_URL}/visit-checklist-question`, values)
      .then(resp => {
        dispatch(action(STORE_VISIT_CHECKLIST_QUESTION.SUCCESS, resp.data))
        return resp
      })
      .catch(e => dispatch(actionFailed(STORE_VISIT_CHECKLIST_QUESTION, e)))
  }
}

export function updateVisitChecklistQuestion(id, values) {
  return dispatch => {
    dispatch(action(UPDATE_VISIT_CHECKLIST_QUESTION.ACTION))
    return axios
      .put(`${config.API_URL}/visit-checklist-question/${id}`, values)
      .then(resp => {
        dispatch(action(UPDATE_VISIT_CHECKLIST_QUESTION.SUCCESS, resp.data))
        return resp
      })
      .catch(e => dispatch(actionFailed(UPDATE_VISIT_CHECKLIST_QUESTION, e)))
  }
}

export function reorderVisitChecklistQuestions(questions) {
  return dispatch => {
    dispatch(action(REORDER_VISIT_CHECKLIST_QUESTIONS.ACTION))
    return axios
      .post(`${config.API_URL}/visit-checklist-question/reorder`, { questions })
      .then(resp => {
        dispatch(action(REORDER_VISIT_CHECKLIST_QUESTIONS.SUCCESS, resp.data))
        return resp
      })
      .catch(e => dispatch(actionFailed(REORDER_VISIT_CHECKLIST_QUESTIONS, e)))
  }
}

export function deleteVisitChecklistQuestion(id) {
  return dispatch => {
    dispatch(action(DELETE_VISIT_CHECKLIST_QUESTION.ACTION))
    return axios
      .delete(`${config.API_URL}/visit-checklist-question/${id}`)
      .then(resp => {
        dispatch(action(DELETE_VISIT_CHECKLIST_QUESTION.SUCCESS, resp.data))
        return resp
      })
      .catch(e => dispatch(actionFailed(DELETE_VISIT_CHECKLIST_QUESTION, e)))
  }
}
